import React, { useState, useEffect } from 'react'
import {
  Row,
  Col,
  PAYPAL_THEME,
  Button,
  Tabs,
  TabPanel,
  Link,
  ShareIcon,
  HeadingText,
  BodyText,
} from '@paypalcorp/pp-react'
// import useApi from '../../../hooks/api'
import { recordDynamicEvent } from '../../../components/common/analytics/utils'
import { useApplicationContext } from '../../../context/ApplicationContext'

import Spinner from '../../../components/common/spinner'
import { Message, injectWorldReady } from '@paypalcorp/worldready-react'
import { Link as RouterLink } from 'react-router-dom'
import { CopyToClipboardButtonBanner } from '../../../components/common/copy-to-clipboard-button-banner'
import { saveBannerProgress } from '../../../utils/session-utils'
import { getUserType } from '../../../utils/user-utils'
import { useMessage } from '../../../hooks'

function SandboxPayments({ setBannerPage }) {
  const [tabIndex, setTabIndex] = useState(0)
  const { sysColorBackgroundMediumContrast } = PAYPAL_THEME
  const localizedMsg = useMessage()

  const {
    user,
    logger,
    csrf,
    enviroment,
    setReloadPage,
    setCurrentEnvironment,
    card,
    account,
    homePageDataLoading,
    setCurrentBannerStep,
    isWebLLSUser,
  } = useApplicationContext()

  useEffect(() => {
    if (homePageDataLoading === undefined || homePageDataLoading === true) {
      return
    }
  }, [homePageDataLoading]) // re-trigger effect if these states change

  function switchTabIndex(index) {
    setTabIndex(index)
  }

  return (
    <>
      <Row>
        <Col xs={10} className="banner-title_row">
          <HeadingText size="sm">
            <Message id="onboarding-banner.sandboxPaymentsTitle" />
          </HeadingText>
        </Col>
      </Row>
      <Row>
        <Col xs={9} className="banner-payment_tabs">
          <Tabs
            name="PaymentsTabs"
            selectedTabIdx={tabIndex}
            tabs={[
              {
                label: localizedMsg('onboarding-banner.test-payments.tabOne'),
                id: 'payments-tab1',
                panelId: 'payments-panel1',
              },
              {
                label: localizedMsg('onboarding-banner.test-payments.tabTwo'),
                id: 'payments-tab2',
                panelId: 'payments-panel2',
              },
              {
                label: localizedMsg('onboarding-banner.test-payments.tabThree'),
                id: 'payments-tab3',
                panelId: 'payments-panel3',
              },
              {
                label: localizedMsg('onboarding-banner.test-payments.tabFour'),
                id: 'payments-tab4',
                panelId: 'payments-panel4',
              },
            ]}
            onClick={(e, index) => {
              switchTabIndex(index)
              recordDynamicEvent(
                `onboarding_banner_test_payment_tabs,click,${index}`,
              )
            }}
            className="banner-payment_tabs"
          >
            <TabPanel
              id="payments-tab1"
              tabId="payments-panel1"
              style={{ marginLeft: '1.5rem' }}
            >
              {!homePageDataLoading ? (
                <div>
                  <Row className="banner-credentials_border">
                    <Col xs={2}>
                      <BodyText
                        style={{ color: sysColorBackgroundMediumContrast }}
                      >
                        <Message id="onboarding-banner.test-payments.cardnumber" />
                      </BodyText>
                    </Col>
                    <Col className="banner-credentials_values-col">
                      <BodyText id="successRef">{card?.card_number}</BodyText>
                    </Col>
                    <Col
                      style={{ padding: '0px' }}
                      className="banner-credentials_values-col"
                    >
                      <CopyToClipboardButtonBanner
                        infoToCopy={card?.card_number}
                        analitycsOrigen="sandbox-payments-card_number"
                      >
                        {' '}
                      </CopyToClipboardButtonBanner>
                    </Col>
                  </Row>
                  <Row
                    className="banner-credentials_border"
                    style={{ paddingBottom: '10px' }}
                  >
                    <Col xs={2}>
                      <BodyText
                        style={{ color: sysColorBackgroundMediumContrast }}
                      >
                        <Message id="onboarding-banner.test-payments.expirydate" />
                      </BodyText>
                    </Col>
                    <Col className="banner-credentials_values-col">
                      <BodyText>Any</BodyText>
                    </Col>
                  </Row>
                  <Row className="banner-credentials_border">
                    <Col xs={2}>
                      <BodyText
                        style={{ color: sysColorBackgroundMediumContrast }}
                      >
                        <Message id="onboarding-banner.test-payments.cvvcode" />
                      </BodyText>
                    </Col>
                    <Col className="banner-credentials_values-col">
                      <BodyText>Any</BodyText>
                    </Col>
                  </Row>
                </div>
              ) : (
                <Spinner size="md" />
              )}
            </TabPanel>
            <TabPanel
              id="payments-tab2"
              tabId="payments-panel2"
              style={{ marginLeft: '1.5rem' }}
            >
              <div>
                <Row className="banner-test_payments_border">
                  <Col xs={3}>
                    <BodyText strong>
                      <Message id="onboarding-banner.test-payments.testName" />
                    </BodyText>
                  </Col>
                  <Col xs={4}>
                    <BodyText strong>
                      <Message id="onboarding-banner.test-payments.trigger" />
                    </BodyText>
                  </Col>
                  <Col xs={4}>
                    <BodyText strong>
                      <Message id="onboarding-banner.test-payments.processorResponse" />
                    </BodyText>
                  </Col>
                </Row>
                <Row className="banner-test_payments_border">
                  <Col xs={3}>
                    <BodyText
                      style={{ color: sysColorBackgroundMediumContrast }}
                    >
                      <Message id="onboarding-banner.test-payments.fraudulentCard" />
                    </BodyText>
                  </Col>
                  <Col xs={4}>
                    <BodyText
                      style={{ color: sysColorBackgroundMediumContrast }}
                    >
                      <Message id="onboarding-banner.test-payments.triggers.ccreject.sf" />
                    </BodyText>
                  </Col>
                  <Col xs={4}>
                    <BodyText
                      style={{ color: sysColorBackgroundMediumContrast }}
                    >
                      <Message id="onboarding-banner.test-payments.processor.one" />
                    </BodyText>
                  </Col>
                </Row>
                <Row className="banner-test_payments_border">
                  <Col xs={3}>
                    <BodyText
                      style={{ color: sysColorBackgroundMediumContrast }}
                    >
                      <Message id="onboarding-banner.test-payments.declinedCard" />
                    </BodyText>
                  </Col>
                  <Col xs={4}>
                    <BodyText
                      style={{ color: sysColorBackgroundMediumContrast }}
                    >
                      <Message id="onboarding-banner.test-payments.triggers.ccreject.bankError" />
                    </BodyText>
                  </Col>
                  <Col xs={4}>
                    <BodyText
                      style={{ color: sysColorBackgroundMediumContrast }}
                    >
                      <Message id="onboarding-banner.test-payments.processor.two" />
                    </BodyText>
                  </Col>
                </Row>
                <Row className="banner-test_payments_border">
                  <Col xs={3}>
                    <BodyText
                      style={{ color: sysColorBackgroundMediumContrast }}
                    >
                      <Message id="onboarding-banner.test-payments.cvcFails" />
                    </BodyText>
                  </Col>
                  <Col xs={4}>
                    <BodyText
                      style={{ color: sysColorBackgroundMediumContrast }}
                    >
                      <Message id="onboarding-banner.test-payments.triggers.ccreject.cvv" />
                    </BodyText>
                  </Col>
                  <Col xs={4}>
                    <BodyText
                      style={{ color: sysColorBackgroundMediumContrast }}
                    >
                      <Message id="onboarding-banner.test-payments.processor.three" />
                    </BodyText>
                  </Col>
                </Row>
                <Row className="banner-test_payments_border">
                  <Col xs={3}>
                    <BodyText
                      style={{ color: sysColorBackgroundMediumContrast }}
                    >
                      <Message id="onboarding-banner.test-payments.expiredCard" />
                    </BodyText>
                  </Col>
                  <Col xs={4}>
                    <BodyText
                      style={{ color: sysColorBackgroundMediumContrast }}
                    >
                      <Message id="onboarding-banner.test-payments.triggers.ccreject.ec" />
                    </BodyText>
                  </Col>
                  <Col xs={4}>
                    <BodyText
                      style={{ color: sysColorBackgroundMediumContrast }}
                    >
                      <Message id="onboarding-banner.test-payments.processor.four" />
                    </BodyText>
                  </Col>
                </Row>
              </div>
            </TabPanel>
            <TabPanel
              id="payments-tab3"
              tabId="payments-panel3"
              style={{ marginLeft: '1.5rem' }}
            >
              <div>
                <Row>
                  <Col>
                    <Row className="banner-test_payments_border">
                      <Col xs={12}>
                        <BodyText strong>
                          <Message id="onboarding-banner.test-payments.successfulAuth" />
                        </BodyText>
                      </Col>
                    </Row>
                    <Row className="banner-test_payments_border">
                      <Col xs={4}>
                        <BodyText
                          style={{ color: sysColorBackgroundMediumContrast }}
                        >
                          <Message id="onboarding-banner.test-payments.visa" />
                        </BodyText>
                      </Col>
                      <Col xs={8}>
                        <BodyText>
                          <Message id="onboarding-banner.test-payments.threeds.visa.success" />
                        </BodyText>
                      </Col>
                    </Row>
                    <Row className="banner-test_payments_border">
                      <Col xs={4}>
                        <BodyText
                          style={{ color: sysColorBackgroundMediumContrast }}
                        >
                          <Message id="onboarding-banner.test-payments.mastercard" />
                        </BodyText>
                      </Col>
                      <Col xs={8}>
                        <BodyText>
                          <Message id="onboarding-banner.test-payments.threeds.mc.success" />
                        </BodyText>
                      </Col>
                    </Row>
                    <Row className="banner-test_payments_border">
                      <Col xs={4}>
                        <BodyText
                          style={{ color: sysColorBackgroundMediumContrast }}
                        >
                          <Message id="onboarding-banner.test-payments.expirydate" />
                        </BodyText>
                      </Col>
                      <Col xs={8}>
                        <BodyText>
                          <Message id="onboarding-banner.test-payments.threeds.expiryValue" />
                        </BodyText>
                      </Col>
                    </Row>
                    <Row className="banner-test_payments_border">
                      <Col xs={4}>
                        <BodyText
                          style={{ color: sysColorBackgroundMediumContrast }}
                        >
                          <Message id="onboarding-banner.test-payments.cvvcode" />
                        </BodyText>
                      </Col>
                      <Col xs={8}>
                        <BodyText>
                          <Message id="onboarding-banner.test-payments.threeds.cvcValue" />
                        </BodyText>
                      </Col>
                    </Row>
                  </Col>
                  <Col>
                    <Row className="banner-test_payments_border">
                      <Col xs={12}>
                        <BodyText strong>
                          <Message id="onboarding-banner.test-payments.failedSig" />
                        </BodyText>
                      </Col>
                    </Row>
                    <Row className="banner-test_payments_border">
                      <Col xs={4}>
                        <BodyText
                          style={{ color: sysColorBackgroundMediumContrast }}
                        >
                          <Message id="onboarding-banner.test-payments.visa" />
                        </BodyText>
                      </Col>
                      <Col xs={8}>
                        <BodyText>
                          <Message id="onboarding-banner.test-payments.threeds.visa.failed" />
                        </BodyText>
                      </Col>
                    </Row>
                    <Row className="banner-test_payments_border">
                      <Col xs={4}>
                        <BodyText
                          style={{ color: sysColorBackgroundMediumContrast }}
                        >
                          <Message id="onboarding-banner.test-payments.mastercard" />
                        </BodyText>
                      </Col>
                      <Col xs={8}>
                        <BodyText>
                          <Message id="onboarding-banner.test-payments.threeds.mc.failed" />
                        </BodyText>
                      </Col>
                    </Row>
                    <Row className="banner-test_payments_border">
                      <Col xs={4}>
                        <BodyText
                          style={{ color: sysColorBackgroundMediumContrast }}
                        >
                          <Message id="onboarding-banner.test-payments.expirydate" />
                        </BodyText>
                      </Col>
                      <Col xs={8}>
                        <BodyText>
                          <Message id="onboarding-banner.test-payments.threeds.expiryValue" />
                        </BodyText>
                      </Col>
                    </Row>
                    <Row className="banner-test_payments_border">
                      <Col xs={4}>
                        <BodyText
                          style={{ color: sysColorBackgroundMediumContrast }}
                        >
                          <Message id="onboarding-banner.test-payments.cvvcode" />
                        </BodyText>
                      </Col>
                      <Col xs={8}>
                        <BodyText>
                          <Message id="onboarding-banner.test-payments.threeds.cvcValue" />
                        </BodyText>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            </TabPanel>
            <TabPanel
              id="payments-tab4"
              tabId="payments-panel4"
              style={{ marginLeft: '1.5rem' }}
            >
              {!homePageDataLoading ? (
                <div>
                  <Row>
                    <Col>
                      <Row className="banner-test_payments_border">
                        <Col xs={2}>
                          <BodyText
                            style={{ color: sysColorBackgroundMediumContrast }}
                          >
                            <Message id="onboarding-banner.test-payments.paypal.email" />
                          </BodyText>
                        </Col>
                        <Col
                          style={{ display: 'flex', justifyContent: 'middle' }}
                        >
                          <BodyText
                            id="emailRef"
                            style={{ paddingRight: '10px' }}
                          >
                            {account?.accountDetails?.primary_email_alias}
                          </BodyText>
                          <CopyToClipboardButtonBanner
                            infoToCopy={
                              account?.accountDetails?.primary_email_alias
                            }
                            analitycsOrigen="sandbox-payments-primary_email"
                          >
                            {' '}
                          </CopyToClipboardButtonBanner>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Row className="banner-test_payments_border">
                        <Col xs={2}>
                          <BodyText
                            style={{ color: sysColorBackgroundMediumContrast }}
                          >
                            <Message id="onboarding-banner.test-payments.paypal.password" />
                          </BodyText>
                        </Col>
                        <Col
                          style={{ display: 'flex', justifyContent: 'middle' }}
                        >
                          <BodyText
                            id="passwordRef"
                            style={{ paddingRight: '10px' }}
                          >
                            {account?.accountDetails?.password}
                          </BodyText>

                          <CopyToClipboardButtonBanner
                            infoToCopy={account?.accountDetails?.password}
                            analitycsOrigen="sandbox-payments-password"
                          >
                            {' '}
                          </CopyToClipboardButtonBanner>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Row className="banner-test_payments_border">
                        <Col xs={2}>
                          <BodyText
                            style={{ color: sysColorBackgroundMediumContrast }}
                          >
                            <Message id="onboarding-banner.test-payments.paypal.type" />
                          </BodyText>
                        </Col>
                        <Col>
                          <BodyText>
                            {account?.accountDetails?.account_type}
                          </BodyText>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </div>
              ) : (
                <Spinner size="md" />
              )}
            </TabPanel>
          </Tabs>
        </Col>
        <Col xs={3} className="banner-testing_options">
          {tabIndex === 0 && (
            <Link
              href="https://developer.paypal.com/api/rest/sandbox/card-testing/#link-creditcardgeneratorfortesting"
              target="_blank"
              rel="noreferrer"
              onClick={() =>
                recordDynamicEvent(
                  `onboarding_banner_test_payments,click,cc_generator`,
                )
              }
              className="banner-testing_options_link"
            >
              <Message id="onboarding-banner.test-payments.more.testing.ccgen" />{' '}
              <ShareIcon size="sm" />
            </Link>
          )}
          {tabIndex === 1 && (
            <Link
              href="https://developer.paypal.com/tools/sandbox/card-testing/"
              target="_blank"
              rel="noreferrer"
              onClick={() =>
                recordDynamicEvent(
                  `onboarding_banner_test_payments,click,card_testing_docs`,
                )
              }
              className="banner-testing_options_link"
            >
              <Message id="onboarding-banner.test-payments.more.testing.failedCards" />{' '}
              <ShareIcon size="sm" />
            </Link>
          )}
          {tabIndex === 2 && (
            <Link
              href="https://developer.paypal.com/docs/checkout/advanced/customize/3d-secure/test/"
              target="_blank"
              rel="noreferrer"
              onClick={() =>
                recordDynamicEvent(
                  `onboarding_banner_test_payments,click,3ds_docs`,
                )
              }
              className="banner-testing_options_link"
            >
              <Message id="onboarding-banner.test-payments.more.testing.threeds" />{' '}
              <ShareIcon size="sm" />
            </Link>
          )}
          {tabIndex === 3 && (
            <Link
              to={'/accounts/'}
              as={RouterLink}
              onClick={() =>
                recordDynamicEvent(
                  `onboarding_banner_test_payments,click,sb_accounts`,
                )
              }
              className="banner-testing_options_link"
            >
              <Message id="onboarding-banner.test-payments.more.testing.accounts" />{' '}
              <ShareIcon size="sm" />
            </Link>
          )}
        </Col>
      </Row>
      <Row>
        <Col>
          <Button
            size="md"
            secondary
            onClick={() => {
              const sessionObject = {
                bannerPage: 4,
              }
              saveBannerProgress(csrf, logger, sessionObject)
              setBannerPage(4)
              setCurrentBannerStep(sessionObject)
              recordDynamicEvent('onboarding_banner_pages,click,next,step4')
              const accountType = getUserType(user)
              if (
                (isWebLLSUser && accountType === 'BUSINESS') ||
                accountType !== 'BUSINESS'
              ) {
                setCurrentEnvironment('sandbox')
              } else if (enviroment === 'sandbox') {
                setCurrentEnvironment('live')
                setReloadPage('yes')
              }
            }}
          >
            <Message id="onboarding-banner.test-payments.next.accept.livepayment" />
          </Button>
        </Col>
      </Row>
    </>
  )
}

export default injectWorldReady(SandboxPayments)
